"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AddImageButton = _interopRequireDefault(require("./AddImageButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var imageButtonBuilder = function imageButtonBuilder(fileManagerUploadedFileAccess) {
  return function (_ref) {
    var onInsertImage = _ref.onInsertImage;
    return _react.default.createElement(_AddImageButton.default, {
      fileManagerUploadedFileAccess: fileManagerUploadedFileAccess,
      onChange: onInsertImage
    });
  };
};

imageButtonBuilder.propTypes = {
  onInsertImage: _propTypes.default.func.isRequired
};
var _default = imageButtonBuilder;
exports.default = _default;
module.exports = exports.default;